import { toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type { IAssessHivFormValues, IAssessHivModel, IAssessHivSubmitResult } from '@/types/screening/assess-hiv';

const ASSESS_HIV_ENDPOINT = '/api/register/assess-hiv';

const defaultAssessHivModel: IAssessHivModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessHiv,
    hasHiv: null,
};

export const useAssessHiv = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_HIV_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessHivModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IAssessHivFormValues, DashRegistrationStep, IAssessHivSubmitResult>(
        url,
        (values) => ({
            hasHiv: toIntOrNull(values.hasHiv),
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
